<template>
    <div>
        <!-- <label class="font-bold" :class="enable ? 'text-gray-500' : 'text-blue-500'" for="">{{title}}</label> -->
        <p class="font-bold" :class="enable ? 'text-black' : 'text-gray-400'">{{title}}</p>
        <!-- {{radioValue.length}} -->
        <button @click.prevent="showSelectStatus = !showSelectStatus" :disabled="!enable" :class="enable ? 'text-black border-gray-500 hover:bg-gray-300 hover:border-gray-300' : 'text-gray-400 bg-[#CDCDCD]'" class="transition-all form-select border rounded-2xl w-full text-left max-h-[42px] mt-1 overflow-hidden overflow-ellipsis whitespace-nowrap" ref="input" style="white-space: nowrap">
            {{radioValue?.name ? radioValue.name : placeholder}}
        </button>
        <div :class="showSelectStatus ? '' : 'hidden'" class="flex flex-col border border-gray-300 bg-white rounded-2xl mt-2 max-h-[23vh] overflow-y-scroll no-scroll-bar">
            <label class="flex items-center gap-x-2 p-2" :class="option == options[0] ? '' : 'border-t-2'" v-for="option in options" :key="option">
                <input type="radio" :value="option" @click="setValue(option); onChange && onChange(option)" v-model="radioValue">
                <p>{{option.name}}</p>
            </label>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            title: String,
            options: Object,
            enable: {
                type: Boolean,
                default: true
            },
            placeholder: String,
            onChange: Object,
            clear: false,
            initialValue: Object,
            modelValue: Object
        },
        emits: ['updateValue'],
        data() {
            return {
                radioValue: this.initialValue,
                showSelectStatus: false
            }
        },
        watch: {
            clear() {
                if(this.clear) {
                    this.radioValue = ''
                }
            },
            modelValue(newValue) {

                if(newValue != this.radioValue) {
                    this.radioValue = newValue;
                }
            }
        },
        methods: {
            setValue(value) {
                this.$emit('updateValue', value);
                this.showSelectStatus = false;
            }
        }
    }
</script>
<style scoped>
    /* Hide scrollbar for Chrome, Safari and Opera */
    /* .no-scroll-bar::-webkit-scrollbar {
        display: none;
    } */

    /* Hide scrollbar for IE, Edge and Firefox */
    /* .no-scroll-bar {
        -ms-overflow-style: none;
        scrollbar-width: none;
    } */
</style>
